import React, { useEffect, useState } from "react";
import { classnames } from "../../utils/text";
import DataComponent from "../DataComponent";
import { isArray } from "lodash-es";
import { enterOnlyNumber } from "../../utils/number";
import { autoHyphen } from "../../utils/replace";

const BillForm = ({ type, onChange, form, errors, formType }) => {
  const [fields, setFields] = useState([]);

  useEffect(() => {
    setFields([
      [
        {
          title: "등록\n번호",
          key: `${type}BizNo`,
          type: "input",
          className: "font-size-13",
          required: true,
          onKeyDown: enterOnlyNumber,
          onKeyUp: (e) => {
            autoHyphen("comNum", Number(e.target.value));
          },
          options: {
            placeholder: formType === "detail" ? " " : "등록번호 입력",
            disabled: formType === "detail",
          },
        },
        {
          title: "종사업장번호",
          key: `${type}BizSubNo`,
          className: "font-size-13",
          onKeyDown: enterOnlyNumber,
          type: "input",
          options: {
            placeholder: formType === "detail" ? " " : "종사업장번호 입력",
            disabled: formType === "detail",
          },
        },
      ],
      [
        {
          title: "상호",
          key: `${type}CorpName`,
          type: "input",
          className: "font-size-13",
          required: true,
          options: {
            placeholder: formType === "detail" ? " " : "상호 입력",
            disabled: formType === "detail",
          },
        },
        {
          title: "성명",
          key: `${type}RepName`,
          type: "input",
          className: "font-size-13",
          required: true,
          options: {
            placeholder: formType === "detail" ? " " : "성명 입력",
            disabled: formType === "detail",
          },
        },
      ],
      [
        {
          title: "사업장",
          key: `${type}Address`,
          type: "input",
          className: "font-size-11",
          options: {
            placeholder: formType === "detail" ? " " : "사업장 입력",
            disabled: formType === "detail",
          },
        },
      ],
      [
        {
          title: "업태",
          key: `${type}BizCategory`,
          type: "input",
          className: "font-size-13",
          options: {
            placeholder: formType === "detail" ? " " : "업태 입력",
            disabled: formType === "detail",
          },
        },
        {
          title: "업종",
          key: `${type}BizItem`,
          type: "input",
          className: "font-size-13",
          options: {
            placeholder: formType === "detail" ? " " : "업종 입력",
            disabled: formType === "detail",
          },
        },
      ],
      [
        {
          id: 'email',
          title: "이메일",
          key: type === 'sup' ? `supEmail` : 'byrEmail1',
          type: "input",
          className: "font-size-13 ",
          options: {
            placeholder: formType === "detail" ? " " : "이메일 입력",
            disabled: formType === "detail",
          },
        },
      ],
    ]);
  }, [type, formType]);

  const getInvoiceTitle = () => {
    let title = "";
    switch (type) {
      case "sup":
        title = "공 급 자";
        break;
      case "byr":
        title = "공 급 받 는 자";
        break;
      default:
        break;
    }
    return title;
  };

  return (
    <div className={classnames("bill-form", type)}>
      <div className={classnames("title-wrap", type)}>
        <span className={classnames("bill-title", type)}>{getInvoiceTitle()}</span>
      </div>
      <table className="form-wrap">
        <tbody>
          {isArray(fields) &&
            fields.map((_fields, index) => (
              <tr key={index} className={classnames("form-row", type, _fields[0].id)}>
                {isArray(_fields) &&
                  _fields.map((field, idx) => (
                    <React.Fragment key={idx}>
                      <td className={classnames("form-title-wrap", type)}>
                        {field.required && (
                          <span className="required-option">*</span>
                        )}
                        <span>{field.title}</span>
                      </td>
                      <td
                        className="form-input-wrap"
                        colSpan={_fields.length === 1 ? 3 : 1}
                      >
                        <DataComponent
                          form={form}
                          field={field}
                          onChange={onChange}
                        />
                        {errors && errors[field.key] && (
                          <div className="message">
                            <p className="error-message">{errors[field.key]}</p>
                          </div>
                        )}
                        {field.key === 'byrEmail1' && <div className="mt-3">
                          <DataComponent
                            form={form}
                            field={{
                              ...field, key: 'byrEmail2', options: {
                                placeholder: formType === "detail" ? " " : "이메일2 입력",
                                disabled: formType === "detail",
                              }
                            }}
                            onChange={onChange}
                          />
                          {errors && errors['byrEmail2'] && (
                            <div className="message">
                              <p className="error-message">{errors['byrEmail2']}</p>
                            </div>
                          )}
                        </div>}
                      </td>
                    </React.Fragment>
                  ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default BillForm;

// 공급자 등록번호 invoicerCorpNum
// 공급자 종사업장번호 invoicerEstablishNo
// 공급자 상호 invoicerCorpName
// 공급자 성명 invoicerCEOName
// 공급자 사업장 invoicerAddr
// 공급자 업태 invoicerBizType
// 공급자 업종 invoicerBizClass
// 공급자 이메일 invoicerEmail1
// 공급자 이메일 invoicerEmail2

// 공급받는자 등록번호 invoiceeCorpNum
// 공급받는자 종사업장번호 invoiceeEstablishNo
// 공급받는자 상호 invoiceeCorpName
// 공급받는자 성명 invoiceeCEOName
// 공급받는자 사업장 invoiceeAddr
// 공급받는자 업태 invoiceeBizType
// 공급받는자 업종 invoiceeBizClass
// 공급받는자 이메일 invoiceeEmail1
// 공급받는자 이메일 invoiceeEmail2

// {
//   "clientIdx": 0,
//   "writeEmployeeIdx": 0,
//   "invoiceType": "string",
//   "taxType": "string",
//   "invoicerCorpNum": "string",
//   "invoicerEstablishNo?": "string",
//   "invoicerCorpName": "string",
//   "invoicerCEOName": "string",
//   "invoicerAddr": "string",
//   "invoicerBizType": "string",
//   "invoicerBizClass": "string",
//   "invoicerContactName": "string",
//   "invoicerDeptName": "string",
//   "invoicerTEL": "string",
//   "invoicerHP": "string",
//   "invoicerEmail1": "string",
//   "invoicerEmail2": "string",
//   "invoiceeCorpNum": "string",
//   "invoiceeEstablishNo": "string",
//   "invoiceeCorpName": "string",
//   "invoiceeCEOName": "string",
//   "invoiceeAddr": "string",
//   "invoiceeBizType": "string",
//   "invoiceeBizClass": "string",
//   "invoiceeContactName": "string",
//   "invoiceeDeptName": "string",
//   "invoiceeTEL": "string",
//   "invoiceeHP": "string",
//   "invoiceeEmail1": "string",
//   "invoiceeEmail2": "string",
//   "writeDate": "Unknown Type: Dateonly",
//   "remark": "string",
//   "supplyCostTotal": 0,
//   "taxTotal": 0,
//   "totalAmount": 0,
//   "memo": "string",
//   "fileIdxList": [
//     0
//   ],
//   "items": [
//     {
//       "prodCode": "string",
//       "prodName": "string",
//       "prodSize": "string",
//       "qty": 0,
//       "unit": "string",
//       "unitCost": 0,
//       "supplyCost": 0,
//       "tax": 0,
//       "remark": "string"
//       "trDate": "yyyy.MM.dd"
//     }
//   ]
// }
